import { ModelEditor } from "@/3d/components/editor/ModelEditor";
import { EditorStatusBar } from "@/dom/Editor/EditorStatusBar";
import { EditorToolsColumn } from "@/dom/Editor/EditorToolsColumn";
import { Canvas } from "@react-three/fiber";
import React from "react";

export const Editor = () => {
    return (
        <div className="h-100 d-flex flex-column">
            <div className="flex-grow-1 d-flex overflow-hidden">
                <div className="col">
                    <Canvas>
                        <ModelEditor />
                    </Canvas>
                </div>
                <div className="col-3 d-flex flex-column h-100">
                    <EditorToolsColumn />
                </div>
            </div>
            <div className="border-top">
                <EditorStatusBar />
            </div>
        </div>
    );
};
